export const defaultWorkTime = {
    from_hour: 9,
    from_minute: 0,
    to_hour: 19,
    to_minute: 0,
};

export const formatWorkTimePart = (hour, minute = 0) => {
    return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
};

export const normalizeWorkTime = (workTime) => {
    if (!workTime) {
        return {...defaultWorkTime};
    }

    return {
        from_hour: Number.isFinite(Number(workTime.from_hour)) ? Number(workTime.from_hour) : defaultWorkTime.from_hour,
        from_minute: Number.isFinite(Number(workTime.from_minute)) ? Number(workTime.from_minute) : defaultWorkTime.from_minute,
        to_hour: Number.isFinite(Number(workTime.to_hour)) ? Number(workTime.to_hour) : defaultWorkTime.to_hour,
        to_minute: Number.isFinite(Number(workTime.to_minute)) ? Number(workTime.to_minute) : defaultWorkTime.to_minute,
    };
};

export const getOffHoursRange = (workTime) => {
    const normalized = normalizeWorkTime(workTime);

    return {
        from: formatWorkTimePart(normalized.from_hour, normalized.from_minute),
        to: formatWorkTimePart(normalized.to_hour, normalized.to_minute),
    };
};

export const isOffHours = (hour, minute = 0, workTime) => {
    if (hour === null || hour === undefined) {
        return false;
    }

    const normalized = normalizeWorkTime(workTime);
    const time = Number(hour) * 60 + Number(minute);
    const from = normalized.from_hour * 60 + normalized.from_minute;
    const to = normalized.to_hour * 60 + normalized.to_minute;

    if (from === to) {
        return false;
    }

    if (from < to) {
        return time < from || time >= to;
    }

    return time >= to && time < from;
};

export const hasOffHoursSelection = (startHours, finishHours, workTime) => {
    return isOffHours(startHours, 0, workTime) || isOffHours(finishHours, 0, workTime);
};

export const getOffHoursNoticeText = (workTime, lang = 'ru') => {
    const range = getOffHoursRange(workTime);

    if (lang === 'en') {
        return `Car pickup and return from ${range.to} to ${range.from} outside office hours is charged separately. The surcharge will be calculated depending on the pickup location.`;
    }

    return `Подача и возврат автомобиля с ${range.to} до ${range.from} вне офиса, оплачивается отдельно. Доплата будет рассчитана в зависимости от места подачи.`;
};
